import { allTrackers } from "app/services/track/track";

import { createCrmEnrichmentTrackingService } from "./factory";

const crmEnrichmentTrackingService = createCrmEnrichmentTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));

export default crmEnrichmentTrackingService;
